import { IconSvg, IconSvgProps } from "./icon"

export default function ArrowRight(props: IconSvgProps) {
  return (
    <IconSvg {...props}>
      <path d="M3.64282 12H20.3571" />
      <path d="M15.8571 16.5L20.3571 12L15.8571 7.5" />
    </IconSvg>
  )
}
